module.exports = __webpack_public_path__ + "img/2_254.bb8b680e.png";